import {
  ListWorkflows,
  ReadWorkflow,
} from '@easy-genomics/shared-lib/src/app/types/aws-healthomics/aws-healthomics-api';
import { httpClient } from '@/lib/api/client';

class OmicsWorkflowsModule {
  async list(labId: string): Promise<ListWorkflows> {
    const res = await httpClient.callOmics<ListWorkflows>(
      'GET',
      `/workflow/list-private-workflows?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve omics workflows details');
    }

    return res;
  }

  async get(labId: string, workflowId: string): Promise<ReadWorkflow> {
    const res = await httpClient.callOmics<ReadWorkflow>(
      'GET',
      `/workflow/read-private-workflow/${workflowId}?laboratoryId=${labId}`,
    );

    if (!res) {
      throw new Error('Failed to retrieve omics workflow details');
    }

    return res;
  }
}

export default OmicsWorkflowsModule;
